// // import React, { useState } from "react";
// // import {
// //     FaExclamationTriangle,
// //     FaToggleOn,
// //     FaToggleOff,
// //     FaBox,
// //     FaRupeeSign,
// //     FaStar,
// //     FaSms,
// //     FaMobileAlt,
// //     FaEnvelope,
// //     FaCheckCircle
// // } from "react-icons/fa";

// // const CustomAlerts = () => {
// //     const isMobile = window.innerWidth <= 768;
    
// //     const [alerts, setAlerts] = useState({
// //         lowStock: {
// //             enabled: true,
// //             threshold: 10,
// //             notifyViaSms: true,
// //             notifyViaPush: true,
// //             notifyViaEmail: true,
// //             frequency: 'immediate'
// //         },
// //         highValueOrders: {
// //             enabled: true,
// //             threshold: 5000,
// //             notifyViaSms: true,
// //             notifyViaPush: true,
// //             notifyViaEmail: false,
// //             frequency: 'immediate'
// //         },
// //         customerReviews: {
// //             enabled: true,
// //             ratingThreshold: 3,
// //             notifyViaSms: false,
// //             notifyViaPush: false,
// //             notifyViaEmail: true,
// //             frequency: 'daily'
// //         }
// //     });

// //     const toggleAlert = (alertType) => {
// //         setAlerts(prev => ({
// //             ...prev,
// //             [alertType]: {
// //                 ...prev[alertType],
// //                 enabled: !prev[alertType].enabled
// //             }
// //         }));
// //     };

// //     const updateAlertThreshold = (alertType, value) => {
// //         setAlerts(prev => ({
// //             ...prev,
// //             [alertType]: {
// //                 ...prev[alertType],
// //                 threshold: parseInt(value) || 0
// //             }
// //         }));
// //     };

// //     const toggleAlertChannel = (alertType, channel) => {
// //         setAlerts(prev => ({
// //             ...prev,
// //             [alertType]: {
// //                 ...prev[alertType],
// //                 [channel]: !prev[alertType][channel]
// //             }
// //         }));
// //     };

// //     return (
// //         <div>
// //             {/* Header */}
// //             <div style={{
// //                 display: 'flex',
// //                 alignItems: 'center',
// //                 gap: '15px',
// //                 marginBottom: '20px',
// //                 flexDirection: isMobile ? 'column' : 'row',
// //                 textAlign: isMobile ? 'center' : 'left'
// //             }}>
// //                 <div style={{
// //                     width: isMobile ? '50px' : '60px',
// //                     height: isMobile ? '50px' : '60px',
// //                     borderRadius: '50%',
// //                     backgroundColor: '#fff3e0',
// //                     display: 'flex',
// //                     alignItems: 'center',
// //                     justifyContent: 'center',
// //                     flexShrink: 0
// //                 }}>
// //                     <FaExclamationTriangle style={{
// //                         fontSize: isMobile ? '24px' : '28px',
// //                         color: '#FF9800'
// //                     }} />
// //                 </div>
// //                 <div style={{ flex: 1 }}>
// //                     <h3 style={{
// //                         margin: 0,
// //                         color: '#333',
// //                         fontSize: isMobile ? '18px' : '24px'
// //                     }}>
// //                         Custom Alert Configuration
// //                     </h3>
// //                     <p style={{
// //                         margin: '5px 0 0 0',
// //                         color: '#666',
// //                         fontSize: isMobile ? '13px' : '14px'
// //                     }}>
// //                         Set up custom alerts for specific business events
// //                     </p>
// //                 </div>
// //             </div>

// //             {/* Alert Configuration Cards */}
// //             <div style={{
// //                 display: 'grid',
// //                 gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(350px, 1fr))',
// //                 gap: '20px',
// //                 marginBottom: '30px'
// //             }}>
// //                 {/* Low Stock Alert */}
// //                 <div style={{
// //                     border: '1px solid #e0e0e0',
// //                     borderRadius: '12px',
// //                     padding: isMobile ? '15px' : '25px',
// //                     backgroundColor: '#fff',
// //                     boxShadow: '0 4px 6px rgba(0,0,0,0.05)'
// //                 }}>
// //                     <div style={{
// //                         display: 'flex',
// //                         justifyContent: 'space-between',
// //                         alignItems: 'flex-start',
// //                         marginBottom: '15px'
// //                     }}>
// //                         <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
// //                             <div style={{
// //                                 width: '40px',
// //                                 height: '40px',
// //                                 borderRadius: '50%',
// //                                 backgroundColor: alerts.lowStock.enabled ? '#e8f5e9' : '#f5f5f5',
// //                                 display: 'flex',
// //                                 alignItems: 'center',
// //                                 justifyContent: 'center',
// //                                 flexShrink: 0
// //                             }}>
// //                                 <FaBox style={{
// //                                     fontSize: '20px',
// //                                     color: alerts.lowStock.enabled ? '#4CAF50' : '#ccc'
// //                                 }} />
// //                             </div>
// //                             <div>
// //                                 <h4 style={{
// //                                     margin: 0,
// //                                     color: '#333',
// //                                     fontSize: isMobile ? '16px' : '18px'
// //                                 }}>
// //                                     Low Stock Alert
// //                                 </h4>
// //                                 <p style={{
// //                                     margin: '5px 0 0 0',
// //                                     color: '#666',
// //                                     fontSize: isMobile ? '12px' : '13px'
// //                                 }}>
// //                                     Get notified when inventory is running low
// //                                 </p>
// //                             </div>
// //                         </div>
// //                         <button
// //                             onClick={() => toggleAlert('lowStock')}
// //                             style={{
// //                                 background: 'none',
// //                                 border: 'none',
// //                                 fontSize: isMobile ? '28px' : '32px',
// //                                 color: alerts.lowStock.enabled ? '#4CAF50' : '#ccc',
// //                                 cursor: 'pointer',
// //                                 display: 'flex',
// //                                 alignItems: 'center',
// //                                 flexShrink: 0
// //                             }}
// //                         >
// //                             {alerts.lowStock.enabled ? <FaToggleOn /> : <FaToggleOff />}
// //                         </button>
// //                     </div>

// //                     {alerts.lowStock.enabled && (
// //                         <div>
// //                             <div style={{ marginBottom: '15px' }}>
// //                                 <label style={{
// //                                     display: 'block',
// //                                     marginBottom: '8px',
// //                                     fontSize: isMobile ? '13px' : '14px',
// //                                     fontWeight: '600',
// //                                     color: '#333'
// //                                 }}>
// //                                     Alert when stock falls below:
// //                                 </label>
// //                                 <div style={{
// //                                     display: 'flex',
// //                                     alignItems: 'center',
// //                                     gap: '10px'
// //                                 }}>
// //                                     <input
// //                                         type="number"
// //                                         value={alerts.lowStock.threshold}
// //                                         onChange={(e) => updateAlertThreshold('lowStock', e.target.value)}
// //                                         min="1"
// //                                         max="100"
// //                                         style={{
// //                                             width: isMobile ? '80px' : '100px',
// //                                             padding: '10px',
// //                                             border: '2px solid #e0e0e0',
// //                                             borderRadius: '6px',
// //                                             fontSize: isMobile ? '14px' : '16px'
// //                                         }}
// //                                     />
// //                                     <span style={{
// //                                         fontSize: isMobile ? '13px' : '14px',
// //                                         color: '#666'
// //                                     }}>
// //                                         items
// //                                     </span>
// //                                 </div>
// //                             </div>

// //                             <div style={{ marginBottom: '15px' }}>
// //                                 <label style={{
// //                                     display: 'block',
// //                                     marginBottom: '10px',
// //                                     fontSize: isMobile ? '13px' : '14px',
// //                                     fontWeight: '600',
// //                                     color: '#333'
// //                                 }}>
// //                                     Notification Channels:
// //                                 </label>
// //                                 <div style={{
// //                                     display: 'flex',
// //                                     gap: '10px',
// //                                     flexWrap: 'wrap'
// //                                 }}>
// //                                     {[
// //                                         { key: 'notifyViaSms', label: 'SMS', icon: <FaSms /> },
// //                                         { key: 'notifyViaPush', label: 'Push', icon: <FaMobileAlt /> },
// //                                         { key: 'notifyViaEmail', label: 'Email', icon: <FaEnvelope /> }
// //                                     ].map(channel => (
// //                                         <button
// //                                             key={channel.key}
// //                                             onClick={() => toggleAlertChannel('lowStock', channel.key)}
// //                                             style={{
// //                                                 padding: '6px 12px',
// //                                                 border: `2px solid ${alerts.lowStock[channel.key] ? '#4CAF50' : '#e0e0e0'}`,
// //                                                 backgroundColor: alerts.lowStock[channel.key] ? '#e8f5e9' : 'white',
// //                                                 color: alerts.lowStock[channel.key] ? '#2e7d32' : '#666',
// //                                                 borderRadius: '20px',
// //                                                 cursor: 'pointer',
// //                                                 display: 'flex',
// //                                                 alignItems: 'center',
// //                                                 gap: '6px',
// //                                                 fontSize: isMobile ? '12px' : '13px',
// //                                                 fontWeight: '600',
// //                                                 flexShrink: 0
// //                                             }}
// //                                         >
// //                                             {channel.icon} {channel.label}
// //                                         </button>
// //                                     ))}
// //                                 </div>
// //                             </div>

// //                             <div style={{
// //                                 padding: '10px',
// //                                 backgroundColor: '#e8f5e9',
// //                                 borderRadius: '8px',
// //                                 fontSize: isMobile ? '12px' : '13px',
// //                                 color: '#2e7d32',
// //                                 display: 'flex',
// //                                 alignItems: 'center',
// //                                 gap: '8px'
// //                             }}>
// //                                 <FaCheckCircle />
// //                                 Alert active: Notify when stock is below {alerts.lowStock.threshold} items
// //                             </div>
// //                         </div>
// //                     )}
// //                 </div>

// //                 {/* High-Value Orders Alert */}
// //                 <div style={{
// //                     border: '1px solid #e0e0e0',
// //                     borderRadius: '12px',
// //                     padding: isMobile ? '15px' : '25px',
// //                     backgroundColor: '#fff',
// //                     boxShadow: '0 4px 6px rgba(0,0,0,0.05)'
// //                 }}>
// //                     <div style={{
// //                         display: 'flex',
// //                         justifyContent: 'space-between',
// //                         alignItems: 'flex-start',
// //                         marginBottom: '15px'
// //                     }}>
// //                         <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
// //                             <div style={{
// //                                 width: '40px',
// //                                 height: '40px',
// //                                 borderRadius: '50%',
// //                                 backgroundColor: alerts.highValueOrders.enabled ? '#e3f2fd' : '#f5f5f5',
// //                                 display: 'flex',
// //                                 alignItems: 'center',
// //                                 justifyContent: 'center',
// //                                 flexShrink: 0
// //                             }}>
// //                                 <FaRupeeSign style={{
// //                                     fontSize: '20px',
// //                                     color: alerts.highValueOrders.enabled ? '#2196F3' : '#ccc'
// //                                 }} />
// //                             </div>
// //                             <div>
// //                                 <h4 style={{
// //                                     margin: 0,
// //                                     color: '#333',
// //                                     fontSize: isMobile ? '16px' : '18px'
// //                                 }}>
// //                                     High-Value Orders
// //                                 </h4>
// //                                 <p style={{
// //                                     margin: '5px 0 0 0',
// //                                     color: '#666',
// //                                     fontSize: isMobile ? '12px' : '13px'
// //                                 }}>
// //                                     Alerts for orders above specific value
// //                                 </p>
// //                             </div>
// //                         </div>
// //                         <button
// //                             onClick={() => toggleAlert('highValueOrders')}
// //                             style={{
// //                                 background: 'none',
// //                                 border: 'none',
// //                                 fontSize: isMobile ? '28px' : '32px',
// //                                 color: alerts.highValueOrders.enabled ? '#2196F3' : '#ccc',
// //                                 cursor: 'pointer',
// //                                 display: 'flex',
// //                                 alignItems: 'center',
// //                                 flexShrink: 0
// //                             }}
// //                         >
// //                             {alerts.highValueOrders.enabled ? <FaToggleOn /> : <FaToggleOff />}
// //                         </button>
// //                     </div>

// //                     {alerts.highValueOrders.enabled && (
// //                         <div>
// //                             <div style={{ marginBottom: '15px' }}>
// //                                 <label style={{
// //                                     display: 'block',
// //                                     marginBottom: '8px',
// //                                     fontSize: isMobile ? '13px' : '14px',
// //                                     fontWeight: '600',
// //                                     color: '#333'
// //                                 }}>
// //                                     Alert for orders above:
// //                                 </label>
// //                                 <div style={{
// //                                     display: 'flex',
// //                                     alignItems: 'center',
// //                                     gap: '10px'
// //                                 }}>
// //                                     <span style={{
// //                                         fontSize: isMobile ? '16px' : '18px',
// //                                         fontWeight: 'bold',
// //                                         color: '#2196F3'
// //                                     }}>
// //                                         ₹
// //                                     </span>
// //                                     <input
// //                                         type="number"
// //                                         value={alerts.highValueOrders.threshold}
// //                                         onChange={(e) => updateAlertThreshold('highValueOrders', e.target.value)}
// //                                         min="1000"
// //                                         max="100000"
// //                                         style={{
// //                                             width: isMobile ? '100px' : '120px',
// //                                             padding: '10px',
// //                                             border: '2px solid #e0e0e0',
// //                                             borderRadius: '6px',
// //                                             fontSize: isMobile ? '14px' : '16px'
// //                                         }}
// //                                     />
// //                                 </div>
// //                             </div>

// //                             <div style={{ marginBottom: '15px' }}>
// //                                 <label style={{
// //                                     display: 'block',
// //                                     marginBottom: '10px',
// //                                     fontSize: isMobile ? '13px' : '14px',
// //                                     fontWeight: '600',
// //                                     color: '#333'
// //                                 }}>
// //                                     Notification Channels:
// //                                 </label>
// //                                 <div style={{
// //                                     display: 'flex',
// //                                     gap: '10px',
// //                                     flexWrap: 'wrap'
// //                                 }}>
// //                                     {[
// //                                         { key: 'notifyViaSms', label: 'SMS', icon: <FaSms /> },
// //                                         { key: 'notifyViaPush', label: 'Push', icon: <FaMobileAlt /> },
// //                                         { key: 'notifyViaEmail', label: 'Email', icon: <FaEnvelope /> }
// //                                     ].map(channel => (
// //                                         <button
// //                                             key={channel.key}
// //                                             onClick={() => toggleAlertChannel('highValueOrders', channel.key)}
// //                                             style={{
// //                                                 padding: '6px 12px',
// //                                                 border: `2px solid ${alerts.highValueOrders[channel.key] ? '#2196F3' : '#e0e0e0'}`,
// //                                                 backgroundColor: alerts.highValueOrders[channel.key] ? '#e3f2fd' : 'white',
// //                                                 color: alerts.highValueOrders[channel.key] ? '#1565c0' : '#666',
// //                                                 borderRadius: '20px',
// //                                                 cursor: 'pointer',
// //                                                 display: 'flex',
// //                                                 alignItems: 'center',
// //                                                 gap: '6px',
// //                                                 fontSize: isMobile ? '12px' : '13px',
// //                                                 fontWeight: '600',
// //                                                 flexShrink: 0
// //                                             }}
// //                                         >
// //                                             {channel.icon} {channel.label}
// //                                         </button>
// //                                     ))}
// //                                 </div>
// //                             </div>

// //                             <div style={{
// //                                 padding: '10px',
// //                                 backgroundColor: '#e3f2fd',
// //                                 borderRadius: '8px',
// //                                 fontSize: isMobile ? '12px' : '13px',
// //                                 color: '#1565c0',
// //                                 display: 'flex',
// //                                 alignItems: 'center',
// //                                 gap: '8px'
// //                             }}>
// //                                 <FaCheckCircle />
// //                                 Alert active: Notify for orders above ₹{alerts.highValueOrders.threshold.toLocaleString()}
// //                             </div>
// //                         </div>
// //                     )}
// //                 </div>

// //                 {/* Customer Reviews Alert */}
// //                 <div style={{
// //                     border: '1px solid #e0e0e0',
// //                     borderRadius: '12px',
// //                     padding: isMobile ? '15px' : '25px',
// //                     backgroundColor: '#fff',
// //                     boxShadow: '0 4px 6px rgba(0,0,0,0.05)'
// //                 }}>
// //                     <div style={{
// //                         display: 'flex',
// //                         justifyContent: 'space-between',
// //                         alignItems: 'flex-start',
// //                         marginBottom: '15px'
// //                     }}>
// //                         <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
// //                             <div style={{
// //                                 width: '40px',
// //                                 height: '40px',
// //                                 borderRadius: '50%',
// //                                 backgroundColor: alerts.customerReviews.enabled ? '#fff3e0' : '#f5f5f5',
// //                                 display: 'flex',
// //                                 alignItems: 'center',
// //                                 justifyContent: 'center',
// //                                 flexShrink: 0
// //                             }}>
// //                                 <FaStar style={{
// //                                     fontSize: '20px',
// //                                     color: alerts.customerReviews.enabled ? '#FF9800' : '#ccc'
// //                                 }} />
// //                             </div>
// //                             <div>
// //                                 <h4 style={{
// //                                     margin: 0,
// //                                     color: '#333',
// //                                     fontSize: isMobile ? '16px' : '18px'
// //                                 }}>
// //                                     Customer Reviews
// //                                 </h4>
// //                                 <p style={{
// //                                     margin: '5px 0 0 0',
// //                                     color: '#666',
// //                                     fontSize: isMobile ? '12px' : '13px'
// //                                 }}>
// //                                     Alerts for critical customer reviews
// //                                 </p>
// //                             </div>
// //                         </div>
// //                         <button
// //                             onClick={() => toggleAlert('customerReviews')}
// //                             style={{
// //                                 background: 'none',
// //                                 border: 'none',
// //                                 fontSize: isMobile ? '28px' : '32px',
// //                                 color: alerts.customerReviews.enabled ? '#FF9800' : '#ccc',
// //                                 cursor: 'pointer',
// //                                 display: 'flex',
// //                                 alignItems: 'center',
// //                                 flexShrink: 0
// //                             }}
// //                         >
// //                             {alerts.customerReviews.enabled ? <FaToggleOn /> : <FaToggleOff />}
// //                         </button>
// //                     </div>

// //                     {alerts.customerReviews.enabled && (
// //                         <div>
// //                             <div style={{ marginBottom: '15px' }}>
// //                                 <label style={{
// //                                     display: 'block',
// //                                     marginBottom: '8px',
// //                                     fontSize: isMobile ? '13px' : '14px',
// //                                     fontWeight: '600',
// //                                     color: '#333'
// //                                 }}>
// //                                     Alert for ratings below:
// //                                 </label>
// //                                 <div style={{
// //                                     display: 'flex',
// //                                     alignItems: 'center',
// //                                     gap: '10px'
// //                                 }}>
// //                                     <input
// //                                         type="number"
// //                                         value={alerts.customerReviews.ratingThreshold}
// //                                         onChange={(e) => updateAlertThreshold('customerReviews', e.target.value)}
// //                                         min="1"
// //                                         max="5"
// //                                         step="0.5"
// //                                         style={{
// //                                             width: isMobile ? '80px' : '100px',
// //                                             padding: '10px',
// //                                             border: '2px solid #e0e0e0',
// //                                             borderRadius: '6px',
// //                                             fontSize: isMobile ? '14px' : '16px'
// //                                         }}
// //                                     />
// //                                     <span style={{
// //                                         fontSize: isMobile ? '13px' : '14px',
// //                                         color: '#666'
// //                                     }}>
// //                                         stars
// //                                     </span>
// //                                 </div>
// //                             </div>

// //                             <div style={{
// //                                 padding: '10px',
// //                                 backgroundColor: '#fff3e0',
// //                                 borderRadius: '8px',
// //                                 fontSize: isMobile ? '12px' : '13px',
// //                                 color: '#e65100',
// //                                 display: 'flex',
// //                                 alignItems: 'center',
// //                                 gap: '8px'
// //                             }}>
// //                                 <FaCheckCircle />
// //                                 Alert active: Notify for reviews below {alerts.customerReviews.ratingThreshold} stars
// //                             </div>
// //                         </div>
// //                     )}
// //                 </div>
// //             </div>

// //             {/* Save All Alerts Button */}
// //             <div style={{ marginTop: '20px', textAlign: 'center' }}>
// //                 <button
// //                     onClick={() => alert('All alert configurations saved successfully!')}
// //                     style={{
// //                         backgroundColor: '#A055B0',
// //                         color: 'white',
// //                         border: 'none',
// //                         padding: isMobile ? '12px 30px' : '15px 40px',
// //                         borderRadius: '8px',
// //                         cursor: 'pointer',
// //                         fontSize: isMobile ? '14px' : '16px',
// //                         fontWeight: '600',
// //                         display: 'inline-flex',
// //                         alignItems: 'center',
// //                         gap: '10px',
// //                         boxShadow: '0 4px 15px rgba(160, 85, 176, 0.3)',
// //                         transition: 'all 0.3s ease'
// //                     }}
// //                     onMouseEnter={(e) => {
// //                         e.currentTarget.style.backgroundColor = '#8a4b9b';
// //                         e.currentTarget.style.transform = 'translateY(-2px)';
// //                     }}
// //                     onMouseLeave={(e) => {
// //                         e.currentTarget.style.backgroundColor = '#A055B0';
// //                         e.currentTarget.style.transform = 'translateY(0)';
// //                     }}
// //                 >
// //                     <FaCheckCircle /> Save All Alert Configurations
// //                 </button>
// //             </div>
// //         </div>
// //     );
// // };

// // export default CustomAlerts;



// import React, { useState } from "react";
// import {
//     FaExclamationTriangle,
//     FaBox,
//     FaShoppingCart,
//     FaStar,
//     FaRupeeSign,
//     FaSms,
//     FaMobileAlt,
//     FaEnvelope,
//     FaCheckCircle,
//     FaToggleOn,
//     FaToggleOff
// } from "react-icons/fa";

// function CustomAlerts() {
//     // State for alert configurations
//     const [alerts, setAlerts] = useState({
//         lowStock: {
//             enabled: true,
//             threshold: 10,
//             notifyViaSms: true,
//             notifyViaPush: true,
//             notifyViaEmail: true,
//             category: 'inventory',
//             frequency: 'immediate'
//         },
//         highValueOrders: {
//             enabled: true,
//             threshold: 5000,
//             notifyViaSms: true,
//             notifyViaPush: true,
//             notifyViaEmail: false,
//             category: 'orders',
//             frequency: 'immediate'
//         },
//         newOrders: {
//             enabled: false,
//             threshold: 0,
//             notifyViaSms: false,
//             notifyViaPush: true,
//             notifyViaEmail: false,
//             category: 'orders',
//             frequency: 'immediate'
//         },
//         customerReviews: {
//             enabled: true,
//             ratingThreshold: 3,
//             notifyViaSms: false,
//             notifyViaPush: false,
//             notifyViaEmail: true,
//             category: 'reviews',
//             frequency: 'daily'
//         },
//         paymentReceived: {
//             enabled: true,
//             threshold: 0,
//             notifyViaSms: true,
//             notifyViaPush: true,
//             notifyViaEmail: true,
//             category: 'payments',
//             frequency: 'immediate'
//         }
//     });

//     // Check screen size for responsive design
//     const [isMobile, setIsMobile] = useState(false);

//     React.useEffect(() => {
//         const checkMobile = () => {
//             setIsMobile(window.innerWidth <= 768);
//         };

//         checkMobile();
//         window.addEventListener('resize', checkMobile);
//         return () => window.removeEventListener('resize', checkMobile);
//     }, []);

//     // Toggle alert configuration
//     const toggleAlert = (alertType) => {
//         setAlerts(prev => ({
//             ...prev,
//             [alertType]: {
//                 ...prev[alertType],
//                 enabled: !prev[alertType].enabled
//             }
//         }));
//     };

//     // Update alert threshold
//     const updateAlertThreshold = (alertType, value) => {
//         setAlerts(prev => ({
//             ...prev,
//             [alertType]: {
//                 ...prev[alertType],
//                 threshold: parseInt(value) || 0
//             }
//         }));
//     };

//     // Toggle notification channel for alert
//     const toggleAlertChannel = (alertType, channel) => {
//         setAlerts(prev => ({
//             ...prev,
//             [alertType]: {
//                 ...prev[alertType],
//                 [channel]: !prev[alertType][channel]
//             }
//         }));
//     };

//     // Update alert frequency
//     const updateAlertFrequency = (alertType, frequency) => {
//         setAlerts(prev => ({
//             ...prev,
//             [alertType]: {
//                 ...prev[alertType],
//                 frequency: frequency
//             }
//         }));
//     };

//     return (
//         <div style={{
//             backgroundColor: 'white',
//             borderRadius: '10px',
//             padding: isMobile ? '15px' : '30px',
//             boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
//             marginBottom: '20px',
//             maxWidth: '1200px',
//             margin: '0 auto'
//         }}>
//             <div style={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: '15px',
//                 marginBottom: '20px',
//                 flexDirection: isMobile ? 'column' : 'row',
//                 textAlign: isMobile ? 'center' : 'left'
//             }}>
                
//             </div>

//             {/* Alert Configuration Cards */}
//             <div style={{
//                 display: 'grid',
//                 gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(350px, 1fr))',
//                 gap: '20px',
//                 marginBottom: '30px'
//             }}>
//                 {/* Low Stock Alert */}
//                 <div style={{
//                     border: '1px solid #e0e0e0',
//                     borderRadius: '12px',
//                     padding: isMobile ? '15px' : '25px',
//                     backgroundColor: '#fff',
//                     boxShadow: '0 4px 6px rgba(0,0,0,0.05)'
//                 }}>
//                     <div style={{
//                         display: 'flex',
//                         justifyContent: 'space-between',
//                         alignItems: 'flex-start',
//                         marginBottom: '15px'
//                     }}>
//                         <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//                             <div style={{
//                                 width: '40px',
//                                 height: '40px',
//                                 borderRadius: '50%',
//                                 backgroundColor: alerts.lowStock.enabled ? '#e8f5e9' : '#f5f5f5',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 justifyContent: 'center',
//                                 flexShrink: 0
//                             }}>
//                                 <FaBox style={{
//                                     fontSize: '20px',
//                                     color: alerts.lowStock.enabled ? '#4CAF50' : '#ccc'
//                                 }} />
//                             </div>
//                             <div>
//                                 <h4 style={{
//                                     margin: 0,
//                                     color: '#333',
//                                     fontSize: isMobile ? '16px' : '18px'
//                                 }}>
//                                     Low Stock Alert
//                                 </h4>
//                                 <p style={{
//                                     margin: '5px 0 0 0',
//                                     color: '#666',
//                                     fontSize: isMobile ? '12px' : '13px'
//                                 }}>
//                                     Get notified when inventory is running low
//                                 </p>
//                             </div>
//                         </div>
//                         <button
//                             onClick={() => toggleAlert('lowStock')}
//                             style={{
//                                 background: 'none',
//                                 border: 'none',
//                                 fontSize: isMobile ? '28px' : '32px',
//                                 color: alerts.lowStock.enabled ? '#4CAF50' : '#ccc',
//                                 cursor: 'pointer',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 flexShrink: 0
//                             }}
//                         >
//                             {alerts.lowStock.enabled ? <FaToggleOn /> : <FaToggleOff />}
//                         </button>
//                     </div>

//                     {alerts.lowStock.enabled && (
//                         <div>
//                             <div style={{ marginBottom: '15px' }}>
//                                 <label style={{
//                                     display: 'block',
//                                     marginBottom: '8px',
//                                     fontSize: isMobile ? '13px' : '14px',
//                                     fontWeight: '600',
//                                     color: '#333'
//                                 }}>
//                                     Alert when stock falls below:
//                                 </label>
//                                 <div style={{
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     gap: '10px'
//                                 }}>
//                                     <input
//                                         type="number"
//                                         value={alerts.lowStock.threshold}
//                                         onChange={(e) => updateAlertThreshold('lowStock', e.target.value)}
//                                         min="1"
//                                         max="100"
//                                         style={{
//                                             width: isMobile ? '80px' : '100px',
//                                             padding: '10px',
//                                             border: '2px solid #e0e0e0',
//                                             borderRadius: '6px',
//                                             fontSize: isMobile ? '14px' : '16px'
//                                         }}
//                                     />
//                                     <span style={{
//                                         fontSize: isMobile ? '13px' : '14px',
//                                         color: '#666'
//                                     }}>
//                                         items
//                                     </span>
//                                 </div>
//                             </div>

//                             <div style={{ marginBottom: '15px' }}>
//                                 <label style={{
//                                     display: 'block',
//                                     marginBottom: '10px',
//                                     fontSize: isMobile ? '13px' : '14px',
//                                     fontWeight: '600',
//                                     color: '#333'
//                                 }}>
//                                     Notification Channels:
//                                 </label>
//                                 <div style={{
//                                     display: 'flex',
//                                     gap: '10px',
//                                     flexWrap: 'wrap'
//                                 }}>
//                                     {[
//                                         { key: 'notifyViaSms', label: 'SMS', icon: <FaSms /> },
//                                         { key: 'notifyViaPush', label: 'Push', icon: <FaMobileAlt /> },
//                                         { key: 'notifyViaEmail', label: 'Email', icon: <FaEnvelope /> }
//                                     ].map(channel => (
//                                         <button
//                                             key={channel.key}
//                                             onClick={() => toggleAlertChannel('lowStock', channel.key)}
//                                             style={{
//                                                 padding: '6px 12px',
//                                                 border: `2px solid ${alerts.lowStock[channel.key] ? '#4CAF50' : '#e0e0e0'}`,
//                                                 backgroundColor: alerts.lowStock[channel.key] ? '#e8f5e9' : 'white',
//                                                 color: alerts.lowStock[channel.key] ? '#2e7d32' : '#666',
//                                                 borderRadius: '20px',
//                                                 cursor: 'pointer',
//                                                 display: 'flex',
//                                                 alignItems: 'center',
//                                                 gap: '6px',
//                                                 fontSize: isMobile ? '12px' : '13px',
//                                                 fontWeight: '600',
//                                                 flexShrink: 0
//                                             }}
//                                         >
//                                             {channel.icon} {channel.label}
//                                         </button>
//                                     ))}
//                                 </div>
//                             </div>

//                             <div style={{
//                                 padding: '10px',
//                                 backgroundColor: '#e8f5e9',
//                                 borderRadius: '8px',
//                                 fontSize: isMobile ? '12px' : '13px',
//                                 color: '#2e7d32',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 gap: '8px'
//                             }}>
//                                 <FaCheckCircle />
//                                 Alert active: Notify when stock is below {alerts.lowStock.threshold} items
//                             </div>
//                         </div>
//                     )}
//                 </div>

//                 {/* High-Value Orders Alert */}
//                 <div style={{
//                     border: '1px solid #e0e0e0',
//                     borderRadius: '12px',
//                     padding: isMobile ? '15px' : '25px',
//                     backgroundColor: '#fff',
//                     boxShadow: '0 4px 6px rgba(0,0,0,0.05)'
//                 }}>
//                     <div style={{
//                         display: 'flex',
//                         justifyContent: 'space-between',
//                         alignItems: 'flex-start',
//                         marginBottom: '15px'
//                     }}>
//                         <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//                             <div style={{
//                                 width: '40px',
//                                 height: '40px',
//                                 borderRadius: '50%',
//                                 backgroundColor: alerts.highValueOrders.enabled ? '#e3f2fd' : '#f5f5f5',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 justifyContent: 'center',
//                                 flexShrink: 0
//                             }}>
//                                 <FaRupeeSign style={{
//                                     fontSize: '20px',
//                                     color: alerts.highValueOrders.enabled ? '#2196F3' : '#ccc'
//                                 }} />
//                             </div>
//                             <div>
//                                 <h4 style={{
//                                     margin: 0,
//                                     color: '#333',
//                                     fontSize: isMobile ? '16px' : '18px'
//                                 }}>
//                                     High-Value Orders
//                                 </h4>
//                                 <p style={{
//                                     margin: '5px 0 0 0',
//                                     color: '#666',
//                                     fontSize: isMobile ? '12px' : '13px'
//                                 }}>
//                                     Alerts for orders above specific value
//                                 </p>
//                             </div>
//                         </div>
//                         <button
//                             onClick={() => toggleAlert('highValueOrders')}
//                             style={{
//                                 background: 'none',
//                                 border: 'none',
//                                 fontSize: isMobile ? '28px' : '32px',
//                                 color: alerts.highValueOrders.enabled ? '#2196F3' : '#ccc',
//                                 cursor: 'pointer',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 flexShrink: 0
//                             }}
//                         >
//                             {alerts.highValueOrders.enabled ? <FaToggleOn /> : <FaToggleOff />}
//                         </button>
//                     </div>

//                     {alerts.highValueOrders.enabled && (
//                         <div>
//                             <div style={{ marginBottom: '15px' }}>
//                                 <label style={{
//                                     display: 'block',
//                                     marginBottom: '8px',
//                                     fontSize: isMobile ? '13px' : '14px',
//                                     fontWeight: '600',
//                                     color: '#333'
//                                 }}>
//                                     Alert for orders above:
//                                 </label>
//                                 <div style={{
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     gap: '10px'
//                                 }}>
//                                     <span style={{
//                                         fontSize: isMobile ? '16px' : '18px',
//                                         fontWeight: 'bold',
//                                         color: '#2196F3'
//                                     }}>
//                                         ₹
//                                     </span>
//                                     <input
//                                         type="number"
//                                         value={alerts.highValueOrders.threshold}
//                                         onChange={(e) => updateAlertThreshold('highValueOrders', e.target.value)}
//                                         min="1000"
//                                         max="100000"
//                                         style={{
//                                             width: isMobile ? '100px' : '120px',
//                                             padding: '10px',
//                                             border: '2px solid #e0e0e0',
//                                             borderRadius: '6px',
//                                             fontSize: isMobile ? '14px' : '16px'
//                                         }}
//                                     />
//                                 </div>
//                             </div>

//                             <div style={{ marginBottom: '15px' }}>
//                                 <label style={{
//                                     display: 'block',
//                                     marginBottom: '10px',
//                                     fontSize: isMobile ? '13px' : '14px',
//                                     fontWeight: '600',
//                                     color: '#333'
//                                 }}>
//                                     Notification Channels:
//                                 </label>
//                                 <div style={{
//                                     display: 'flex',
//                                     gap: '10px',
//                                     flexWrap: 'wrap'
//                                 }}>
//                                     {[
//                                         { key: 'notifyViaSms', label: 'SMS', icon: <FaSms /> },
//                                         { key: 'notifyViaPush', label: 'Push', icon: <FaMobileAlt /> },
//                                         { key: 'notifyViaEmail', label: 'Email', icon: <FaEnvelope /> }
//                                     ].map(channel => (
//                                         <button
//                                             key={channel.key}
//                                             onClick={() => toggleAlertChannel('highValueOrders', channel.key)}
//                                             style={{
//                                                 padding: '6px 12px',
//                                                 border: `2px solid ${alerts.highValueOrders[channel.key] ? '#2196F3' : '#e0e0e0'}`,
//                                                 backgroundColor: alerts.highValueOrders[channel.key] ? '#e3f2fd' : 'white',
//                                                 color: alerts.highValueOrders[channel.key] ? '#1565c0' : '#666',
//                                                 borderRadius: '20px',
//                                                 cursor: 'pointer',
//                                                 display: 'flex',
//                                                 alignItems: 'center',
//                                                 gap: '6px',
//                                                 fontSize: isMobile ? '12px' : '13px',
//                                                 fontWeight: '600',
//                                                 flexShrink: 0
//                                             }}
//                                         >
//                                             {channel.icon} {channel.label}
//                                         </button>
//                                     ))}
//                                 </div>
//                             </div>

//                             <div style={{
//                                 padding: '10px',
//                                 backgroundColor: '#e3f2fd',
//                                 borderRadius: '8px',
//                                 fontSize: isMobile ? '12px' : '13px',
//                                 color: '#1565c0',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 gap: '8px'
//                             }}>
//                                 <FaCheckCircle />
//                                 Alert active: Notify for orders above ₹{alerts.highValueOrders.threshold.toLocaleString()}
//                             </div>
//                         </div>
//                     )}
//                 </div>

//                 {/* New Orders Alert */}
//                 <div style={{
//                     border: '1px solid #e0e0e0',
//                     borderRadius: '12px',
//                     padding: isMobile ? '15px' : '25px',
//                     backgroundColor: '#fff',
//                     boxShadow: '0 4px 6px rgba(0,0,0,0.05)'
//                 }}>
//                     <div style={{
//                         display: 'flex',
//                         justifyContent: 'space-between',
//                         alignItems: 'flex-start',
//                         marginBottom: '15px'
//                     }}>
//                         <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//                             <div style={{
//                                 width: '40px',
//                                 height: '40px',
//                                 borderRadius: '50%',
//                                 backgroundColor: alerts.newOrders.enabled ? '#e3f2fd' : '#f5f5f5',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 justifyContent: 'center',
//                                 flexShrink: 0
//                             }}>
//                                 <FaShoppingCart style={{
//                                     fontSize: '20px',
//                                     color: alerts.newOrders.enabled ? '#2196F3' : '#ccc'
//                                 }} />
//                             </div>
//                             <div>
//                                 <h4 style={{
//                                     margin: 0,
//                                     color: '#333',
//                                     fontSize: isMobile ? '16px' : '18px'
//                                 }}>
//                                     New Orders
//                                 </h4>
//                                 <p style={{
//                                     margin: '5px 0 0 0',
//                                     color: '#666',
//                                     fontSize: isMobile ? '12px' : '13px'
//                                 }}>
//                                     Alerts for every new order received
//                                 </p>
//                             </div>
//                         </div>
//                         <button
//                             onClick={() => toggleAlert('newOrders')}
//                             style={{
//                                 background: 'none',
//                                 border: 'none',
//                                 fontSize: isMobile ? '28px' : '32px',
//                                 color: alerts.newOrders.enabled ? '#2196F3' : '#ccc',
//                                 cursor: 'pointer',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 flexShrink: 0
//                             }}
//                         >
//                             {alerts.newOrders.enabled ? <FaToggleOn /> : <FaToggleOff />}
//                         </button>
//                     </div>

//                     {alerts.newOrders.enabled && (
//                         <div>
//                             <div style={{ marginBottom: '15px' }}>
//                                 <label style={{
//                                     display: 'block',
//                                     marginBottom: '10px',
//                                     fontSize: isMobile ? '13px' : '14px',
//                                     fontWeight: '600',
//                                     color: '#333'
//                                 }}>
//                                     Notification Channels:
//                                 </label>
//                                 <div style={{
//                                     display: 'flex',
//                                     gap: '10px',
//                                     flexWrap: 'wrap'
//                                 }}>
//                                     {[
//                                         { key: 'notifyViaSms', label: 'SMS', icon: <FaSms /> },
//                                         { key: 'notifyViaPush', label: 'Push', icon: <FaMobileAlt /> },
//                                         { key: 'notifyViaEmail', label: 'Email', icon: <FaEnvelope /> }
//                                     ].map(channel => (
//                                         <button
//                                             key={channel.key}
//                                             onClick={() => toggleAlertChannel('newOrders', channel.key)}
//                                             style={{
//                                                 padding: '6px 12px',
//                                                 border: `2px solid ${alerts.newOrders[channel.key] ? '#2196F3' : '#e0e0e0'}`,
//                                                 backgroundColor: alerts.newOrders[channel.key] ? '#e3f2fd' : 'white',
//                                                 color: alerts.newOrders[channel.key] ? '#1565c0' : '#666',
//                                                 borderRadius: '20px',
//                                                 cursor: 'pointer',
//                                                 display: 'flex',
//                                                 alignItems: 'center',
//                                                 gap: '6px',
//                                                 fontSize: isMobile ? '12px' : '13px',
//                                                 fontWeight: '600',
//                                                 flexShrink: 0
//                                             }}
//                                         >
//                                             {channel.icon} {channel.label}
//                                         </button>
//                                     ))}
//                                 </div>
//                             </div>

//                             <div style={{ marginBottom: '15px' }}>
//                                 <label style={{
//                                     display: 'block',
//                                     marginBottom: '10px',
//                                     fontSize: isMobile ? '13px' : '14px',
//                                     fontWeight: '600',
//                                     color: '#333'
//                                 }}>
//                                     Notification Frequency:
//                                 </label>
//                                 <div style={{
//                                     display: 'flex',
//                                     gap: '8px',
//                                     flexWrap: 'wrap'
//                                 }}>
//                                     {['immediate', 'hourly', 'daily'].map(freq => (
//                                         <button
//                                             key={freq}
//                                             onClick={() => updateAlertFrequency('newOrders', freq)}
//                                             style={{
//                                                 padding: '6px 12px',
//                                                 border: `2px solid ${alerts.newOrders.frequency === freq ? '#2196F3' : '#e0e0e0'}`,
//                                                 backgroundColor: alerts.newOrders.frequency === freq ? '#e3f2fd' : 'white',
//                                                 color: alerts.newOrders.frequency === freq ? '#1565c0' : '#666',
//                                                 borderRadius: '20px',
//                                                 cursor: 'pointer',
//                                                 fontSize: isMobile ? '12px' : '13px',
//                                                 fontWeight: '600',
//                                                 textTransform: 'capitalize',
//                                                 flexShrink: 0
//                                             }}
//                                         >
//                                             {freq}
//                                         </button>
//                                     ))}
//                                 </div>
//                             </div>

//                             <div style={{
//                                 padding: '10px',
//                                 backgroundColor: '#e3f2fd',
//                                 borderRadius: '8px',
//                                 fontSize: isMobile ? '12px' : '13px',
//                                 color: '#1565c0',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 gap: '8px'
//                             }}>
//                                 <FaCheckCircle />
//                                 Alert active: Notify for all new orders
//                             </div>
//                         </div>
//                     )}
//                 </div>

//                 {/* Customer Reviews Alert */}
//                 <div style={{
//                     border: '1px solid #e0e0e0',
//                     borderRadius: '12px',
//                     padding: isMobile ? '15px' : '25px',
//                     backgroundColor: '#fff',
//                     boxShadow: '0 4px 6px rgba(0,0,0,0.05)'
//                 }}>
//                     <div style={{
//                         display: 'flex',
//                         justifyContent: 'space-between',
//                         alignItems: 'flex-start',
//                         marginBottom: '15px'
//                     }}>
//                         <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//                             <div style={{
//                                 width: '40px',
//                                 height: '40px',
//                                 borderRadius: '50%',
//                                 backgroundColor: alerts.customerReviews.enabled ? '#fff3e0' : '#f5f5f5',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 justifyContent: 'center',
//                                 flexShrink: 0
//                             }}>
//                                 <FaStar style={{
//                                     fontSize: '20px',
//                                     color: alerts.customerReviews.enabled ? '#FF9800' : '#ccc'
//                                 }} />
//                             </div>
//                             <div>
//                                 <h4 style={{
//                                     margin: 0,
//                                     color: '#333',
//                                     fontSize: isMobile ? '16px' : '18px'
//                                 }}>
//                                     Customer Reviews
//                                 </h4>
//                                 <p style={{
//                                     margin: '5px 0 0 0',
//                                     color: '#666',
//                                     fontSize: isMobile ? '12px' : '13px'
//                                 }}>
//                                     Alerts for critical customer reviews
//                                 </p>
//                             </div>
//                         </div>
//                         <button
//                             onClick={() => toggleAlert('customerReviews')}
//                             style={{
//                                 background: 'none',
//                                 border: 'none',
//                                 fontSize: isMobile ? '28px' : '32px',
//                                 color: alerts.customerReviews.enabled ? '#FF9800' : '#ccc',
//                                 cursor: 'pointer',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 flexShrink: 0
//                             }}
//                         >
//                             {alerts.customerReviews.enabled ? <FaToggleOn /> : <FaToggleOff />}
//                         </button>
//                     </div>

//                     {alerts.customerReviews.enabled && (
//                         <div>
//                             <div style={{ marginBottom: '15px' }}>
//                                 <label style={{
//                                     display: 'block',
//                                     marginBottom: '8px',
//                                     fontSize: isMobile ? '13px' : '14px',
//                                     fontWeight: '600',
//                                     color: '#333'
//                                 }}>
//                                     Alert for ratings below:
//                                 </label>
//                                 <div style={{
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     gap: '10px'
//                                 }}>
//                                     <input
//                                         type="number"
//                                         value={alerts.customerReviews.ratingThreshold}
//                                         onChange={(e) => updateAlertThreshold('customerReviews', e.target.value)}
//                                         min="1"
//                                         max="5"
//                                         step="0.5"
//                                         style={{
//                                             width: isMobile ? '80px' : '100px',
//                                             padding: '10px',
//                                             border: '2px solid #e0e0e0',
//                                             borderRadius: '6px',
//                                             fontSize: isMobile ? '14px' : '16px'
//                                         }}
//                                     />
//                                     <span style={{
//                                         fontSize: isMobile ? '13px' : '14px',
//                                         color: '#666'
//                                     }}>
//                                         stars
//                                     </span>
//                                 </div>
//                             </div>

//                             <div style={{ marginBottom: '15px' }}>
//                                 <label style={{
//                                     display: 'block',
//                                     marginBottom: '10px',
//                                     fontSize: isMobile ? '13px' : '14px',
//                                     fontWeight: '600',
//                                     color: '#333'
//                                 }}>
//                                     Notification Channels:
//                                 </label>
//                                 <div style={{
//                                     display: 'flex',
//                                     gap: '10px',
//                                     flexWrap: 'wrap'
//                                 }}>
//                                     {[
//                                         { key: 'notifyViaSms', label: 'SMS', icon: <FaSms /> },
//                                         { key: 'notifyViaPush', label: 'Push', icon: <FaMobileAlt /> },
//                                         { key: 'notifyViaEmail', label: 'Email', icon: <FaEnvelope /> }
//                                     ].map(channel => (
//                                         <button
//                                             key={channel.key}
//                                             onClick={() => toggleAlertChannel('customerReviews', channel.key)}
//                                             style={{
//                                                 padding: '6px 12px',
//                                                 border: `2px solid ${alerts.customerReviews[channel.key] ? '#FF9800' : '#e0e0e0'}`,
//                                                 backgroundColor: alerts.customerReviews[channel.key] ? '#fff3e0' : 'white',
//                                                 color: alerts.customerReviews[channel.key] ? '#e65100' : '#666',
//                                                 borderRadius: '20px',
//                                                 cursor: 'pointer',
//                                                 display: 'flex',
//                                                 alignItems: 'center',
//                                                 gap: '6px',
//                                                 fontSize: isMobile ? '12px' : '13px',
//                                                 fontWeight: '600',
//                                                 flexShrink: 0
//                                             }}
//                                         >
//                                             {channel.icon} {channel.label}
//                                         </button>
//                                     ))}
//                                 </div>
//                             </div>

//                             <div style={{ marginBottom: '15px' }}>
//                                 <label style={{
//                                     display: 'block',
//                                     marginBottom: '10px',
//                                     fontSize: isMobile ? '13px' : '14px',
//                                     fontWeight: '600',
//                                     color: '#333'
//                                 }}>
//                                     Notification Frequency:
//                                 </label>
//                                 <div style={{
//                                     display: 'flex',
//                                     gap: '8px',
//                                     flexWrap: 'wrap'
//                                 }}>
//                                     {['immediate', 'hourly', 'daily'].map(freq => (
//                                         <button
//                                             key={freq}
//                                             onClick={() => updateAlertFrequency('customerReviews', freq)}
//                                             style={{
//                                                 padding: '6px 12px',
//                                                 border: `2px solid ${alerts.customerReviews.frequency === freq ? '#FF9800' : '#e0e0e0'}`,
//                                                 backgroundColor: alerts.customerReviews.frequency === freq ? '#fff3e0' : 'white',
//                                                 color: alerts.customerReviews.frequency === freq ? '#e65100' : '#666',
//                                                 borderRadius: '20px',
//                                                 cursor: 'pointer',
//                                                 fontSize: isMobile ? '12px' : '13px',
//                                                 fontWeight: '600',
//                                                 textTransform: 'capitalize',
//                                                 flexShrink: 0
//                                             }}
//                                         >
//                                             {freq}
//                                         </button>
//                                     ))}
//                                 </div>
//                             </div>

//                             <div style={{
//                                 padding: '10px',
//                                 backgroundColor: '#fff3e0',
//                                 borderRadius: '8px',
//                                 fontSize: isMobile ? '12px' : '13px',
//                                 color: '#e65100',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 gap: '8px'
//                             }}>
//                                 <FaCheckCircle />
//                                 Alert active: Notify for reviews below {alerts.customerReviews.ratingThreshold} stars
//                             </div>
//                         </div>
//                     )}
//                 </div>

//                 {/* Payment Received Alert */}
//                 <div style={{
//                     border: '1px solid #e0e0e0',
//                     borderRadius: '12px',
//                     padding: isMobile ? '15px' : '25px',
//                     backgroundColor: '#fff',
//                     boxShadow: '0 4px 6px rgba(0,0,0,0.05)'
//                 }}>
//                     <div style={{
//                         display: 'flex',
//                         justifyContent: 'space-between',
//                         alignItems: 'flex-start',
//                         marginBottom: '15px'
//                     }}>
//                         <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//                             <div style={{
//                                 width: '40px',
//                                 height: '40px',
//                                 borderRadius: '50%',
//                                 backgroundColor: alerts.paymentReceived.enabled ? '#e8f5e9' : '#f5f5f5',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 justifyContent: 'center',
//                                 flexShrink: 0
//                             }}>
//                                 <FaRupeeSign style={{
//                                     fontSize: '20px',
//                                     color: alerts.paymentReceived.enabled ? '#4CAF50' : '#ccc'
//                                 }} />
//                             </div>
//                             <div>
//                                 <h4 style={{
//                                     margin: 0,
//                                     color: '#333',
//                                     fontSize: isMobile ? '16px' : '18px'
//                                 }}>
//                                     Payment Received
//                                 </h4>
//                                 <p style={{
//                                     margin: '5px 0 0 0',
//                                     color: '#666',
//                                     fontSize: isMobile ? '12px' : '13px'
//                                 }}>
//                                     Alerts for successful payments
//                                 </p>
//                             </div>
//                         </div>
//                         <button
//                             onClick={() => toggleAlert('paymentReceived')}
//                             style={{
//                                 background: 'none',
//                                 border: 'none',
//                                 fontSize: isMobile ? '28px' : '32px',
//                                 color: alerts.paymentReceived.enabled ? '#4CAF50' : '#ccc',
//                                 cursor: 'pointer',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 flexShrink: 0
//                             }}
//                         >
//                             {alerts.paymentReceived.enabled ? <FaToggleOn /> : <FaToggleOff />}
//                         </button>
//                     </div>

//                     {alerts.paymentReceived.enabled && (
//                         <div>
//                             <div style={{ marginBottom: '15px' }}>
//                                 <label style={{
//                                     display: 'block',
//                                     marginBottom: '10px',
//                                     fontSize: isMobile ? '13px' : '14px',
//                                     fontWeight: '600',
//                                     color: '#333'
//                                 }}>
//                                     Notification Channels:
//                                 </label>
//                                 <div style={{
//                                     display: 'flex',
//                                     gap: '10px',
//                                     flexWrap: 'wrap'
//                                 }}>
//                                     {[
//                                         { key: 'notifyViaSms', label: 'SMS', icon: <FaSms /> },
//                                         { key: 'notifyViaPush', label: 'Push', icon: <FaMobileAlt /> },
//                                         { key: 'notifyViaEmail', label: 'Email', icon: <FaEnvelope /> }
//                                     ].map(channel => (
//                                         <button
//                                             key={channel.key}
//                                             onClick={() => toggleAlertChannel('paymentReceived', channel.key)}
//                                             style={{
//                                                 padding: '6px 12px',
//                                                 border: `2px solid ${alerts.paymentReceived[channel.key] ? '#4CAF50' : '#e0e0e0'}`,
//                                                 backgroundColor: alerts.paymentReceived[channel.key] ? '#e8f5e9' : 'white',
//                                                 color: alerts.paymentReceived[channel.key] ? '#2e7d32' : '#666',
//                                                 borderRadius: '20px',
//                                                 cursor: 'pointer',
//                                                 display: 'flex',
//                                                 alignItems: 'center',
//                                                 gap: '6px',
//                                                 fontSize: isMobile ? '12px' : '13px',
//                                                 fontWeight: '600',
//                                                 flexShrink: 0
//                                             }}
//                                         >
//                                             {channel.icon} {channel.label}
//                                         </button>
//                                     ))}
//                                 </div>
//                             </div>

//                             <div style={{
//                                 padding: '10px',
//                                 backgroundColor: '#e8f5e9',
//                                 borderRadius: '8px',
//                                 fontSize: isMobile ? '12px' : '13px',
//                                 color: '#2e7d32',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 gap: '8px'
//                             }}>
//                                 <FaCheckCircle />
//                                 Alert active: Notify for all payment received events
//                             </div>
//                         </div>
//                     )}
//                 </div>
//             </div>

//             {/* Save All Alerts Button */}
//             <div style={{ marginTop: '20px', textAlign: 'center' }}>
//                 <button
//                     onClick={() => alert('All alert configurations saved successfully!')}
//                     style={{
//                         backgroundColor: '#A055B0',
//                         color: 'white',
//                         border: 'none',
//                         padding: isMobile ? '12px 30px' : '15px 40px',
//                         borderRadius: '8px',
//                         cursor: 'pointer',
//                         fontSize: isMobile ? '14px' : '16px',
//                         fontWeight: '600',
//                         display: 'inline-flex',
//                         alignItems: 'center',
//                         gap: '10px',
//                         boxShadow: '0 4px 15px rgba(160, 85, 176, 0.3)',
//                         transition: 'all 0.3s ease'
//                     }}
//                     onMouseEnter={(e) => {
//                         e.currentTarget.style.backgroundColor = '#8a4b9b';
//                         e.currentTarget.style.transform = 'translateY(-2px)';
//                     }}
//                     onMouseLeave={(e) => {
//                         e.currentTarget.style.backgroundColor = '#A055B0';
//                         e.currentTarget.style.transform = 'translateY(0)';
//                     }}
//                 >
//                     <FaCheckCircle /> Save All Alert Configurations
//                 </button>
//             </div>
//         </div>
//     );
// }

// export default CustomAlerts;






import React, { useState } from "react";
import {
    FaExclamationTriangle,
    FaBox,
    FaShoppingCart,
    FaStar,
    FaRupeeSign,
    FaSms,
    FaMobileAlt,
    FaEnvelope,
    FaCheckCircle,
    FaToggleOn,
    FaToggleOff
} from "react-icons/fa";

function CustomAlerts() {
    // State for alert configurations
    const [alerts, setAlerts] = useState({
        lowStock: {
            enabled: true,
            threshold: 10,
            notifyViaSms: true,
            notifyViaPush: true,
            notifyViaEmail: true,
            category: 'inventory',
            frequency: 'immediate'
        },
        highValueOrders: {
            enabled: true,
            threshold: 5000,
            notifyViaSms: true,
            notifyViaPush: true,
            notifyViaEmail: false,
            category: 'orders',
            frequency: 'immediate'
        },
        newOrders: {
            enabled: false,
            threshold: 0,
            notifyViaSms: false,
            notifyViaPush: true,
            notifyViaEmail: false,
            category: 'orders',
            frequency: 'immediate'
        },
        customerReviews: {
            enabled: true,
            ratingThreshold: 3,
            notifyViaSms: false,
            notifyViaPush: false,
            notifyViaEmail: true,
            category: 'reviews',
            frequency: 'daily'
        },
        paymentReceived: {
            enabled: true,
            threshold: 0,
            notifyViaSms: true,
            notifyViaPush: true,
            notifyViaEmail: true,
            category: 'payments',
            frequency: 'immediate'
        }
    });

    // Check screen size for responsive design
    const [isMobile, setIsMobile] = useState(false);

    React.useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // Toggle alert configuration
    const toggleAlert = (alertType) => {
        setAlerts(prev => ({
            ...prev,
            [alertType]: {
                ...prev[alertType],
                enabled: !prev[alertType].enabled
            }
        }));
    };

    // Update alert threshold
    const updateAlertThreshold = (alertType, value) => {
        setAlerts(prev => ({
            ...prev,
            [alertType]: {
                ...prev[alertType],
                threshold: parseInt(value) || 0
            }
        }));
    };

    // Toggle notification channel for alert
    const toggleAlertChannel = (alertType, channel) => {
        setAlerts(prev => ({
            ...prev,
            [alertType]: {
                ...prev[alertType],
                [channel]: !prev[alertType][channel]
            }
        }));
    };

    // Update alert frequency
    const updateAlertFrequency = (alertType, frequency) => {
        setAlerts(prev => ({
            ...prev,
            [alertType]: {
                ...prev[alertType],
                frequency: frequency
            }
        }));
    };

    return (
        <div style={{
            backgroundColor: 'white',
            borderRadius: '10px',
            padding: isMobile ? '15px' : '30px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
            marginBottom: '20px',
            maxWidth: '1200px',
            margin: '0 auto'
        }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '15px',
                marginBottom: '20px',
                flexDirection: isMobile ? 'column' : 'row',
                textAlign: isMobile ? 'center' : 'left'
            }}>
                
            </div>

            {/* Alert Configuration Cards */}
            <div style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(350px, 1fr))',
                gap: '20px',
                marginBottom: '30px'
            }}>
                {/* Low Stock Alert */}
                <div style={{
                    border: '1px solid #e0e0e0',
                    borderRadius: '12px',
                    padding: isMobile ? '15px' : '25px',
                    backgroundColor: '#fff',
                    boxShadow: '0 4px 6px rgba(0,0,0,0.05)'
                }}>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        marginBottom: '15px'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <div style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                backgroundColor: alerts.lowStock.enabled ? '#e8f5e9' : '#f5f5f5',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0
                            }}>
                                <FaBox style={{
                                    fontSize: '20px',
                                    color: alerts.lowStock.enabled ? '#4CAF50' : '#ccc'
                                }} />
                            </div>
                            <div>
                                <h4 style={{
                                    margin: 0,
                                    color: '#333',
                                    fontSize: isMobile ? '16px' : '18px'
                                }}>
                                    Low Stock Alert
                                </h4>
                                <p style={{
                                    margin: '5px 0 0 0',
                                    color: '#666',
                                    fontSize: isMobile ? '12px' : '13px'
                                }}>
                                    Get notified when inventory is running low
                                </p>
                            </div>
                        </div>
                        <button
                            onClick={() => toggleAlert('lowStock')}
                            style={{
                                background: 'none',
                                border: 'none',
                                fontSize: isMobile ? '28px' : '32px',
                                color: alerts.lowStock.enabled ? '#4CAF50' : '#ccc',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                flexShrink: 0
                            }}
                        >
                            {alerts.lowStock.enabled ? <FaToggleOn /> : <FaToggleOff />}
                        </button>
                    </div>

                    {alerts.lowStock.enabled && (
                        <div>
                            <div style={{ marginBottom: '15px' }}>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '8px',
                                    fontSize: isMobile ? '13px' : '14px',
                                    fontWeight: '600',
                                    color: '#333'
                                }}>
                                    Alert when stock falls below:
                                </label>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px'
                                }}>
                                    <input
                                        type="number"
                                        value={alerts.lowStock.threshold}
                                        onChange={(e) => updateAlertThreshold('lowStock', e.target.value)}
                                        min="1"
                                        max="100"
                                        style={{
                                            width: isMobile ? '80px' : '100px',
                                            padding: '10px',
                                            border: '2px solid #e0e0e0',
                                            borderRadius: '6px',
                                            fontSize: isMobile ? '14px' : '16px'
                                        }}
                                    />
                                    <span style={{
                                        fontSize: isMobile ? '13px' : '14px',
                                        color: '#666'
                                    }}>
                                        items
                                    </span>
                                </div>
                            </div>

                            <div style={{ marginBottom: '15px' }}>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '10px',
                                    fontSize: isMobile ? '13px' : '14px',
                                    fontWeight: '600',
                                    color: '#333'
                                }}>
                                    Notification Channels:
                                </label>
                                <div style={{
                                    display: 'flex',
                                    gap: '10px',
                                    flexWrap: 'wrap'
                                }}>
                                    {[
                                        { key: 'notifyViaSms', label: 'SMS', icon: <FaSms /> },
                                        { key: 'notifyViaPush', label: 'Push', icon: <FaMobileAlt /> },
                                        { key: 'notifyViaEmail', label: 'Email', icon: <FaEnvelope /> }
                                    ].map(channel => (
                                        <button
                                            key={channel.key}
                                            onClick={() => toggleAlertChannel('lowStock', channel.key)}
                                            style={{
                                                padding: '6px 12px',
                                                border: `2px solid ${alerts.lowStock[channel.key] ? '#4CAF50' : '#e0e0e0'}`,
                                                backgroundColor: alerts.lowStock[channel.key] ? '#e8f5e9' : 'white',
                                                color: alerts.lowStock[channel.key] ? '#2e7d32' : '#666',
                                                borderRadius: '20px',
                                                cursor: 'pointer',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                fontSize: isMobile ? '12px' : '13px',
                                                fontWeight: '600',
                                                flexShrink: 0
                                            }}
                                        >
                                            {channel.icon} {channel.label}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            <div style={{
                                padding: '10px',
                                backgroundColor: '#e8f5e9',
                                borderRadius: '8px',
                                fontSize: isMobile ? '12px' : '13px',
                                color: '#2e7d32',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}>
                                <FaCheckCircle />
                                Alert active: Notify when stock is below {alerts.lowStock.threshold} items
                            </div>
                        </div>
                    )}
                </div>

                {/* High-Value Orders Alert */}
                <div style={{
                    border: '1px solid #e0e0e0',
                    borderRadius: '12px',
                    padding: isMobile ? '15px' : '25px',
                    backgroundColor: '#fff',
                    boxShadow: '0 4px 6px rgba(0,0,0,0.05)'
                }}>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        marginBottom: '15px'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <div style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                backgroundColor: alerts.highValueOrders.enabled ? '#e3f2fd' : '#f5f5f5',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0
                            }}>
                                <FaRupeeSign style={{
                                    fontSize: '20px',
                                    color: alerts.highValueOrders.enabled ? '#2196F3' : '#ccc'
                                }} />
                            </div>
                            <div>
                                <h4 style={{
                                    margin: 0,
                                    color: '#333',
                                    fontSize: isMobile ? '16px' : '18px'
                                }}>
                                    High-Value Orders
                                </h4>
                                <p style={{
                                    margin: '5px 0 0 0',
                                    color: '#666',
                                    fontSize: isMobile ? '12px' : '13px'
                                }}>
                                    Alerts for orders above specific value
                                </p>
                            </div>
                        </div>
                        <button
                            onClick={() => toggleAlert('highValueOrders')}
                            style={{
                                background: 'none',
                                border: 'none',
                                fontSize: isMobile ? '28px' : '32px',
                                color: alerts.highValueOrders.enabled ? '#2196F3' : '#ccc',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                flexShrink: 0
                            }}
                        >
                            {alerts.highValueOrders.enabled ? <FaToggleOn /> : <FaToggleOff />}
                        </button>
                    </div>

                    {alerts.highValueOrders.enabled && (
                        <div>
                            <div style={{ marginBottom: '15px' }}>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '8px',
                                    fontSize: isMobile ? '13px' : '14px',
                                    fontWeight: '600',
                                    color: '#333'
                                }}>
                                    Alert for orders above:
                                </label>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px'
                                }}>
                                    <span style={{
                                        fontSize: isMobile ? '16px' : '18px',
                                        fontWeight: 'bold',
                                        color: '#2196F3'
                                    }}>
                                        ₹
                                    </span>
                                    <input
                                        type="number"
                                        value={alerts.highValueOrders.threshold}
                                        onChange={(e) => updateAlertThreshold('highValueOrders', e.target.value)}
                                        min="1000"
                                        max="100000"
                                        style={{
                                            width: isMobile ? '100px' : '120px',
                                            padding: '10px',
                                            border: '2px solid #e0e0e0',
                                            borderRadius: '6px',
                                            fontSize: isMobile ? '14px' : '16px'
                                        }}
                                    />
                                </div>
                            </div>

                            <div style={{ marginBottom: '15px' }}>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '10px',
                                    fontSize: isMobile ? '13px' : '14px',
                                    fontWeight: '600',
                                    color: '#333'
                                }}>
                                    Notification Channels:
                                </label>
                                <div style={{
                                    display: 'flex',
                                    gap: '10px',
                                    flexWrap: 'wrap'
                                }}>
                                    {[
                                        { key: 'notifyViaSms', label: 'SMS', icon: <FaSms /> },
                                        { key: 'notifyViaPush', label: 'Push', icon: <FaMobileAlt /> },
                                        { key: 'notifyViaEmail', label: 'Email', icon: <FaEnvelope /> }
                                    ].map(channel => (
                                        <button
                                            key={channel.key}
                                            onClick={() => toggleAlertChannel('highValueOrders', channel.key)}
                                            style={{
                                                padding: '6px 12px',
                                                border: `2px solid ${alerts.highValueOrders[channel.key] ? '#2196F3' : '#e0e0e0'}`,
                                                backgroundColor: alerts.highValueOrders[channel.key] ? '#e3f2fd' : 'white',
                                                color: alerts.highValueOrders[channel.key] ? '#1565c0' : '#666',
                                                borderRadius: '20px',
                                                cursor: 'pointer',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                fontSize: isMobile ? '12px' : '13px',
                                                fontWeight: '600',
                                                flexShrink: 0
                                            }}
                                        >
                                            {channel.icon} {channel.label}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            <div style={{
                                padding: '10px',
                                backgroundColor: '#e3f2fd',
                                borderRadius: '8px',
                                fontSize: isMobile ? '12px' : '13px',
                                color: '#1565c0',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}>
                                <FaCheckCircle />
                                Alert active: Notify for orders above ₹{alerts.highValueOrders.threshold.toLocaleString()}
                            </div>
                        </div>
                    )}
                </div>

                {/* New Orders Alert */}
                <div style={{
                    border: '1px solid #e0e0e0',
                    borderRadius: '12px',
                    padding: isMobile ? '15px' : '25px',
                    backgroundColor: '#fff',
                    boxShadow: '0 4px 6px rgba(0,0,0,0.05)'
                }}>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        marginBottom: '15px'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <div style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                backgroundColor: alerts.newOrders.enabled ? '#e3f2fd' : '#f5f5f5',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0
                            }}>
                                <FaShoppingCart style={{
                                    fontSize: '20px',
                                    color: alerts.newOrders.enabled ? '#2196F3' : '#ccc'
                                }} />
                            </div>
                            <div>
                                <h4 style={{
                                    margin: 0,
                                    color: '#333',
                                    fontSize: isMobile ? '16px' : '18px'
                                }}>
                                    New Orders
                                </h4>
                                <p style={{
                                    margin: '5px 0 0 0',
                                    color: '#666',
                                    fontSize: isMobile ? '12px' : '13px'
                                }}>
                                    Alerts for every new order received
                                </p>
                            </div>
                        </div>
                        <button
                            onClick={() => toggleAlert('newOrders')}
                            style={{
                                background: 'none',
                                border: 'none',
                                fontSize: isMobile ? '28px' : '32px',
                                color: alerts.newOrders.enabled ? '#2196F3' : '#ccc',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                flexShrink: 0
                            }}
                        >
                            {alerts.newOrders.enabled ? <FaToggleOn /> : <FaToggleOff />}
                        </button>
                    </div>

                    {alerts.newOrders.enabled && (
                        <div>
                            <div style={{ marginBottom: '15px' }}>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '10px',
                                    fontSize: isMobile ? '13px' : '14px',
                                    fontWeight: '600',
                                    color: '#333'
                                }}>
                                    Notification Channels:
                                </label>
                                <div style={{
                                    display: 'flex',
                                    gap: '10px',
                                    flexWrap: 'wrap'
                                }}>
                                    {[
                                        { key: 'notifyViaSms', label: 'SMS', icon: <FaSms /> },
                                        { key: 'notifyViaPush', label: 'Push', icon: <FaMobileAlt /> },
                                        { key: 'notifyViaEmail', label: 'Email', icon: <FaEnvelope /> }
                                    ].map(channel => (
                                        <button
                                            key={channel.key}
                                            onClick={() => toggleAlertChannel('newOrders', channel.key)}
                                            style={{
                                                padding: '6px 12px',
                                                border: `2px solid ${alerts.newOrders[channel.key] ? '#2196F3' : '#e0e0e0'}`,
                                                backgroundColor: alerts.newOrders[channel.key] ? '#e3f2fd' : 'white',
                                                color: alerts.newOrders[channel.key] ? '#1565c0' : '#666',
                                                borderRadius: '20px',
                                                cursor: 'pointer',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                fontSize: isMobile ? '12px' : '13px',
                                                fontWeight: '600',
                                                flexShrink: 0
                                            }}
                                        >
                                            {channel.icon} {channel.label}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            <div style={{ marginBottom: '15px' }}>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '10px',
                                    fontSize: isMobile ? '13px' : '14px',
                                    fontWeight: '600',
                                    color: '#333'
                                }}>
                                    Notification Frequency:
                                </label>
                                <div style={{
                                    display: 'flex',
                                    gap: '8px',
                                    flexWrap: 'wrap'
                                }}>
                                    {['immediate', 'hourly', 'daily'].map(freq => (
                                        <button
                                            key={freq}
                                            onClick={() => updateAlertFrequency('newOrders', freq)}
                                            style={{
                                                padding: '6px 12px',
                                                border: `2px solid ${alerts.newOrders.frequency === freq ? '#2196F3' : '#e0e0e0'}`,
                                                backgroundColor: alerts.newOrders.frequency === freq ? '#e3f2fd' : 'white',
                                                color: alerts.newOrders.frequency === freq ? '#1565c0' : '#666',
                                                borderRadius: '20px',
                                                cursor: 'pointer',
                                                fontSize: isMobile ? '12px' : '13px',
                                                fontWeight: '600',
                                                textTransform: 'capitalize',
                                                flexShrink: 0
                                            }}
                                        >
                                            {freq}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            <div style={{
                                padding: '10px',
                                backgroundColor: '#e3f2fd',
                                borderRadius: '8px',
                                fontSize: isMobile ? '12px' : '13px',
                                color: '#1565c0',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}>
                                <FaCheckCircle />
                                Alert active: Notify for all new orders
                            </div>
                        </div>
                    )}
                </div>

                {/* Customer Reviews Alert */}
                <div style={{
                    border: '1px solid #e0e0e0',
                    borderRadius: '12px',
                    padding: isMobile ? '15px' : '25px',
                    backgroundColor: '#fff',
                    boxShadow: '0 4px 6px rgba(0,0,0,0.05)'
                }}>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        marginBottom: '15px'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <div style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                backgroundColor: alerts.customerReviews.enabled ? '#fff3e0' : '#f5f5f5',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0
                            }}>
                                <FaStar style={{
                                    fontSize: '20px',
                                    color: alerts.customerReviews.enabled ? '#FF9800' : '#ccc'
                                }} />
                            </div>
                            <div>
                                <h4 style={{
                                    margin: 0,
                                    color: '#333',
                                    fontSize: isMobile ? '16px' : '18px'
                                }}>
                                    Customer Reviews
                                </h4>
                                <p style={{
                                    margin: '5px 0 0 0',
                                    color: '#666',
                                    fontSize: isMobile ? '12px' : '13px'
                                }}>
                                    Alerts for critical customer reviews
                                </p>
                            </div>
                        </div>
                        <button
                            onClick={() => toggleAlert('customerReviews')}
                            style={{
                                background: 'none',
                                border: 'none',
                                fontSize: isMobile ? '28px' : '32px',
                                color: alerts.customerReviews.enabled ? '#FF9800' : '#ccc',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                flexShrink: 0
                            }}
                        >
                            {alerts.customerReviews.enabled ? <FaToggleOn /> : <FaToggleOff />}
                        </button>
                    </div>

                    {alerts.customerReviews.enabled && (
                        <div>
                            <div style={{ marginBottom: '15px' }}>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '8px',
                                    fontSize: isMobile ? '13px' : '14px',
                                    fontWeight: '600',
                                    color: '#333'
                                }}>
                                    Alert for ratings below:
                                </label>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px'
                                }}>
                                    <input
                                        type="number"
                                        value={alerts.customerReviews.ratingThreshold}
                                        onChange={(e) => updateAlertThreshold('customerReviews', e.target.value)}
                                        min="1"
                                        max="5"
                                        step="0.5"
                                        style={{
                                            width: isMobile ? '80px' : '100px',
                                            padding: '10px',
                                            border: '2px solid #e0e0e0',
                                            borderRadius: '6px',
                                            fontSize: isMobile ? '14px' : '16px'
                                        }}
                                    />
                                    <span style={{
                                        fontSize: isMobile ? '13px' : '14px',
                                        color: '#666'
                                    }}>
                                        stars
                                    </span>
                                </div>
                            </div>

                            <div style={{ marginBottom: '15px' }}>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '10px',
                                    fontSize: isMobile ? '13px' : '14px',
                                    fontWeight: '600',
                                    color: '#333'
                                }}>
                                    Notification Channels:
                                </label>
                                <div style={{
                                    display: 'flex',
                                    gap: '10px',
                                    flexWrap: 'wrap'
                                }}>
                                    {[
                                        { key: 'notifyViaSms', label: 'SMS', icon: <FaSms /> },
                                        { key: 'notifyViaPush', label: 'Push', icon: <FaMobileAlt /> },
                                        { key: 'notifyViaEmail', label: 'Email', icon: <FaEnvelope /> }
                                    ].map(channel => (
                                        <button
                                            key={channel.key}
                                            onClick={() => toggleAlertChannel('customerReviews', channel.key)}
                                            style={{
                                                padding: '6px 12px',
                                                border: `2px solid ${alerts.customerReviews[channel.key] ? '#FF9800' : '#e0e0e0'}`,
                                                backgroundColor: alerts.customerReviews[channel.key] ? '#fff3e0' : 'white',
                                                color: alerts.customerReviews[channel.key] ? '#e65100' : '#666',
                                                borderRadius: '20px',
                                                cursor: 'pointer',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                fontSize: isMobile ? '12px' : '13px',
                                                fontWeight: '600',
                                                flexShrink: 0
                                            }}
                                        >
                                            {channel.icon} {channel.label}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            <div style={{ marginBottom: '15px' }}>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '10px',
                                    fontSize: isMobile ? '13px' : '14px',
                                    fontWeight: '600',
                                    color: '#333'
                                }}>
                                    Notification Frequency:
                                </label>
                                <div style={{
                                    display: 'flex',
                                    gap: '8px',
                                    flexWrap: 'wrap'
                                }}>
                                    {['immediate', 'hourly', 'daily'].map(freq => (
                                        <button
                                            key={freq}
                                            onClick={() => updateAlertFrequency('customerReviews', freq)}
                                            style={{
                                                padding: '6px 12px',
                                                border: `2px solid ${alerts.customerReviews.frequency === freq ? '#FF9800' : '#e0e0e0'}`,
                                                backgroundColor: alerts.customerReviews.frequency === freq ? '#fff3e0' : 'white',
                                                color: alerts.customerReviews.frequency === freq ? '#e65100' : '#666',
                                                borderRadius: '20px',
                                                cursor: 'pointer',
                                                fontSize: isMobile ? '12px' : '13px',
                                                fontWeight: '600',
                                                textTransform: 'capitalize',
                                                flexShrink: 0
                                            }}
                                        >
                                            {freq}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            <div style={{
                                padding: '10px',
                                backgroundColor: '#fff3e0',
                                borderRadius: '8px',
                                fontSize: isMobile ? '12px' : '13px',
                                color: '#e65100',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}>
                                <FaCheckCircle />
                                Alert active: Notify for reviews below {alerts.customerReviews.ratingThreshold} stars
                            </div>
                        </div>
                    )}
                </div>

                {/* Payment Received Alert */}
                <div style={{
                    border: '1px solid #e0e0e0',
                    borderRadius: '12px',
                    padding: isMobile ? '15px' : '25px',
                    backgroundColor: '#fff',
                    boxShadow: '0 4px 6px rgba(0,0,0,0.05)'
                }}>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        marginBottom: '15px'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <div style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                backgroundColor: alerts.paymentReceived.enabled ? '#e8f5e9' : '#f5f5f5',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0
                            }}>
                                <FaRupeeSign style={{
                                    fontSize: '20px',
                                    color: alerts.paymentReceived.enabled ? '#4CAF50' : '#ccc'
                                }} />
                            </div>
                            <div>
                                <h4 style={{
                                    margin: 0,
                                    color: '#333',
                                    fontSize: isMobile ? '16px' : '18px'
                                }}>
                                    Payment Received
                                </h4>
                                <p style={{
                                    margin: '5px 0 0 0',
                                    color: '#666',
                                    fontSize: isMobile ? '12px' : '13px'
                                }}>
                                    Alerts for successful payments
                                </p>
                            </div>
                        </div>
                        <button
                            onClick={() => toggleAlert('paymentReceived')}
                            style={{
                                background: 'none',
                                border: 'none',
                                fontSize: isMobile ? '28px' : '32px',
                                color: alerts.paymentReceived.enabled ? '#4CAF50' : '#ccc',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                flexShrink: 0
                            }}
                        >
                            {alerts.paymentReceived.enabled ? <FaToggleOn /> : <FaToggleOff />}
                        </button>
                    </div>

                    {alerts.paymentReceived.enabled && (
                        <div>
                            <div style={{ marginBottom: '15px' }}>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '10px',
                                    fontSize: isMobile ? '13px' : '14px',
                                    fontWeight: '600',
                                    color: '#333'
                                }}>
                                    Notification Channels:
                                </label>
                                <div style={{
                                    display: 'flex',
                                    gap: '10px',
                                    flexWrap: 'wrap'
                                }}>
                                    {[
                                        { key: 'notifyViaSms', label: 'SMS', icon: <FaSms /> },
                                        { key: 'notifyViaPush', label: 'Push', icon: <FaMobileAlt /> },
                                        { key: 'notifyViaEmail', label: 'Email', icon: <FaEnvelope /> }
                                    ].map(channel => (
                                        <button
                                            key={channel.key}
                                            onClick={() => toggleAlertChannel('paymentReceived', channel.key)}
                                            style={{
                                                padding: '6px 12px',
                                                border: `2px solid ${alerts.paymentReceived[channel.key] ? '#4CAF50' : '#e0e0e0'}`,
                                                backgroundColor: alerts.paymentReceived[channel.key] ? '#e8f5e9' : 'white',
                                                color: alerts.paymentReceived[channel.key] ? '#2e7d32' : '#666',
                                                borderRadius: '20px',
                                                cursor: 'pointer',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                fontSize: isMobile ? '12px' : '13px',
                                                fontWeight: '600',
                                                flexShrink: 0
                                            }}
                                        >
                                            {channel.icon} {channel.label}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            <div style={{
                                padding: '10px',
                                backgroundColor: '#e8f5e9',
                                borderRadius: '8px',
                                fontSize: isMobile ? '12px' : '13px',
                                color: '#2e7d32',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}>
                                <FaCheckCircle />
                                Alert active: Notify for all payment received events
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {/* Save All Alerts Button */}
            <div style={{ marginTop: '20px', textAlign: 'center' }}>
                <button
                    onClick={() => alert('All alert configurations saved successfully!')}
                    style={{
                        backgroundColor: '#A055B0',
                        color: 'white',
                        border: 'none',
                        padding: isMobile ? '12px 30px' : '15px 40px',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontSize: isMobile ? '14px' : '16px',
                        fontWeight: '600',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '10px',
                        boxShadow: '0 4px 15px rgba(160, 85, 176, 0.3)',
                        transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#8a4b9b';
                        e.currentTarget.style.transform = 'translateY(-2px)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#A055B0';
                        e.currentTarget.style.transform = 'translateY(0)';
                    }}
                >
                    <FaCheckCircle /> Save All Alert Configurations
                </button>
            </div>
        </div>
    );
}

export default CustomAlerts;